import { createTheme } from "@mui/material/styles";

/** Fixed theme for login/signup — unchanged when admin switches light/dark */
const loginTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#d2c381", dark: "#baa96e", contrastText: "#fff" },
    background: { default: "#1a1d22", paper: "#ffffff" },
    text: { primary: "#1f2329", secondary: "#6a6f79" },
  },
  typography: {
    fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 7,
          backgroundColor: "#fff",
        },
        input: {
          color: "#1f2329",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { color: "#6a6f79" },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: { color: "#6a6f79" },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default loginTheme;
